import {
  GET_CUSTOMER_FAILURE,
  GET_CUSTOMER_REQUEST,
  GET_CUSTOMER_SUCCESS,
  SET_CHECKBOX_DATA,
  SET_CUSTOMER_GROUPS,
  SET_GROUP_CONSOLIDATIONS,
} from "../actionTypes";
import getAPI from "@API/index";

export const setCheckBoxData = (payload) => {
  return {
    type: SET_CHECKBOX_DATA,
    payload: payload,
  };
};

//fetch one customer
export const getCustomerRequest = () => {
  return {
    type: GET_CUSTOMER_REQUEST,
  };
};

const getCustomerSuccess = (customer) => {
  return {
    type: GET_CUSTOMER_SUCCESS,
    payload: customer,
  };
};

export const getCustomer = (id) => {
  return (dispatch) => {
    dispatch(getCustomerRequest());
    getAPI()
      .request({
        method: "get",
        url: `/api/Customer/${id}`,
      })
      .then((data) => {
        let customer = {
          clients: [],
          users: [],
          finDataRequests: data.finDataRequests,
          id: data.id,
          name: data.name,
          externalId: data.externalId,
          createdAt: data.createdAt,
          type: data.type,
          email: data.email,
          status: data.status,
          updatedAt: data.updatedAt,
          totalRequests: data.totalRequests,
          requestsLeft: data.requestsLeft,
          subscriptionStart: data.subscriptionStart,
          subscriptionUntil: data.subscriptionUntil,
          subscriptionRequestAmount: data.subscriptionRequestAmount,
          isActiveSubscription: data.isActiveSubscription,
          ServerUrl: data.ServerUrl,
          defaultLanguage: data.defaultLanguage,
          oneSPackageName: data.oneSPackageName,
          customerRole: data.customerRole,
          leadNotificationEmails: data.leadNotificationEmails ?? [],
        };

        data.clients?.forEach((client, index) => {
          customer.clients[index] = {};
          customer.clients[index].id = client.id;
          customer.clients[index].externalId = client.externalId;
          customer.clients[index].name = client.name;
          customer.clients[index].createdAt = client.createdAt.split("T")[0];
          customer.clients[index].accountSystemType = client.accountSystemType;
          customer.clients[index].creditRating = client.creditRating;
          customer.clients[index].creditRatingColor = client.creditRatingColor;
          customer.clients[index].aversCreditRatingColor =
            client.aversCreditRatingColor;
          customer.clients[index].riskSignalColor = client.riskSignalColor;
          customer.clients[index].triggeredStopFactors = client.triggeredStopFactors;
          customer.clients[index].role = client.role;
          customer.clients[index].customerGroup = client.customerGroup;
        });
        data.users?.forEach((user, index) => {
          customer.users[index] = {};
          customer.users[index].id = user.id;
          customer.users[index].status = user.status;
          customer.users[index].userName = user.userName;
          customer.users[index].fullName = user.fullName;
          customer.users[index].department = user.department;
          customer.users[index].createdAt = user.createdAt;
          customer.users[index].role = user.role;
        });
        data.finDataRequests?.forEach((request, index) => {
          customer.finDataRequests[index] = {};
          customer.finDataRequests[index].clientId = request.clientId;
          customer.finDataRequests[index].clientExternalId =
            request.clientExternalId;
          customer.finDataRequests[index].clientName = request.clientName;
          customer.finDataRequests[index].id = request.id;
          customer.finDataRequests[index].createdAt = request.createdAt;
          customer.finDataRequests[index].updatedAt = request.updatedAt;
          customer.finDataRequests[index].startDate =
            request.startDate.split("T")[0];
          customer.finDataRequests[index].endDate =
            request.endDate.split("T")[0];
          customer.finDataRequests[index].finDatafile = request.finDataFile;
          customer.finDataRequests[index].status = request.status;
          customer.finDataRequests[index].multiplicity = request.multiplicity;
          customer.finDataRequests[index].reportType = request.reportType;
          customer.finDataRequests[index].transferType = request.transferType;
          customer.finDataRequests[index].type = request.type;
          customer.finDataRequests[index].language = request.language;
          customer.finDataRequests[index].hasDocuments = request.hasDocuments;
        });
        dispatch(getCustomerSuccess(customer));
      })
      .catch((error) => {
        // do nothing
      });
  };
};

const setCustomerGroups = (list) => {
  return {
    type: SET_CUSTOMER_GROUPS,
    payload: list,
  };
};

export const getCustomerGroups = (customerId) => {
  return (dispatch) => {
    getAPI()
      .request({
        url: `/api/Customer/${customerId}/groups`,
        errorIfNotOk: false,
      })
      .then((data) => {
        dispatch(setCustomerGroups(data));
      })
      .catch((error) => {
        // do nothing
      });
  };
};

const setGroupData = (data) => {
  return {
    type: SET_GROUP_CONSOLIDATIONS,
    payload: data,
  };
};
export const getGroupData = (customerId, groupId) => {
  return (dispatch) => {
    getAPI()
      .request({
        url: `/api/customer/${customerId}/groups/${groupId}`,
        errorIfNotOk: false,
      })
      .then((data) => {
        dispatch(setGroupData(data));
      })
      .catch((error) => {
        // do nothing
      });
  };
};
